<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { computed } from "vue"
import { useStore } from "vuex"

const store = useStore()

// cart module state
const cart = computed(() => store.state.cart.cart)
const pending = computed(() => store.state.cart.pending)
</script>
